import { create } from 'zustand';

interface AnimationPreviewState {
  animation: string | null;
  isOpen: boolean;
  open: (animation: string) => void;
  close: () => void;
}

/**
 * Imperative controller for the manifest Animation Preview dialog. Used by the
 * `previewAnimation` field-action handler — calling `open('tada')` reveals a
 * small dialog that plays the animate.css class once and offers a "Play" button
 * to replay. Mirrors scio1's `previewAnimation` modal (liveTvAdsModal.js:272-298).
 */
export const useAnimationPreviewStore = create<AnimationPreviewState>((set) => ({
  animation: null,
  isOpen: false,
  open: (animation) => set({ animation, isOpen: true }),
  close: () => set({ animation: null, isOpen: false }),
}));
